module.exports = __webpack_public_path__ + "img/104.424291b7.jpg";